export default "__VITE_ASSET__cpRcdUGL__"